import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { SelectItem } from 'primeng/api';
import { dateFormat } from '@core/_utils/date.utils';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'page-delete-docs',
    templateUrl: './page-delete-docs.component.html',
    styleUrls: ['./page-delete-docs.component.scss'],
})
export class PageDeleteDocsComponent implements OnInit {
    public deleteDocs = [];
    public isDesktop: boolean = false;
    public error = false;
    public archivList: SelectItem[];
    public listColumns = [];

    constructor(
        public menu: MenuServiceInt,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService,
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
    }

    ngOnInit() {
        this.listColumns = [
            { header: this.translate.instant('&doc_name'), field: 'doc_name', type: 'String', sort: 'doc_name' },
            { header: this.translate.instant('&doc_creationdate'), field: 'doc_creationdate', type: 'DateTime', sort: 'doc_creationdate' },
            { header: this.translate.instant('&doc_deletedate'), field: 'doc_deletedate', type: 'DateTime', sort: 'doc_deletedate' },
            { header: this.translate.instant('&doc_deleteuser'), field: 'doc_deleteuser', type: 'String', sort: 'doc_deleteuser' },
            { header: this.translate.instant('&doc_archiv'), field: 'doc_archiv', type: 'String', sort: 'doc_archiv' },
            { header: this.translate.instant('&doc_docid'), field: 'doc_docid', type: 'String' },
        ];
        this.archivList = [
            { label: this.translate.instant('All'), value: null },
            { label: this.translate.instant('Archiv'), value: '1' },
            { label: this.translate.instant('Archiv_No'), value: '0' },
        ];

        this.findAll();
        this.commonService.checkReset();
    }

    private async findAll() {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getdeletedocs', ''));
            this.deleteDocs = wRes.DeleteDocs.map((item) => {
                item.doc_creationdate = item.doc_creationdate + '|' + dateFormat(item.doc_creationdate, 'dd/MM/yyyy HH:mm:ss');
                item.doc_deletedate = item.doc_deletedate + '|' + dateFormat(item.doc_deletedate, 'dd/MM/yyyy HH:mm:ss');
                item.doc_name = item.doc_name + item.doc_ext;
                return item;
            });            
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));            
        }
    }
}
